
import React from 'react';
import { cn } from "@/lib/utils";

const ExampleGallery = () => {
  const marketingIdeas = [
    {
      id: 1,
      title: "KI-gestützte Produktvideos für Schweizer Luxusmarken",
      platform: "Instagram & TikTok",
      description: "Hochwertige KI-Produktvisualisierungen mit emotionalen Testimonials steigern die Conversion-Rate für Luxusmarken in der Schweiz um bis zu 47%. Besonders wirksam für Kosmetik, Uhren und Premium-Accessoires.",
      gradientClass: "from-purple-600/20 to-blue-600/20"
    },
    {
      id: 2,
      title: "Mehrsprachige KI-Videos für digitale Transformation",
      platform: "LinkedIn & Facebook",
      description: "Schweizer Unternehmen profitieren von viersprachigen KI-Videos (DE/FR/IT/EN) für ihre digitale Transformation. Nachweislich 89% bessere Informationsvermittlung komplexer Tech-Themen durch visuelle AI-Erklärformate.",
      gradientClass: "from-blue-600/20 to-teal-600/20"
    },
    {
      id: 3,
      title: "Lokale KI-Video-Werbekampagnen Schweiz",
      platform: "Facebook & Instagram",
      description: "Hyperlokal optimierte KI-Videowerbung für Standorte in Zürich, Basel, Bern & Genf bringt 73% mehr lokalen Traffic. Perfekte Integration von lokaler SEO und Videomarketing für maximale regionale Sichtbarkeit.",
      gradientClass: "from-teal-600/20 to-amber-600/20"
    },
    {
      id: 4,
      title: "Explainer-Videos mit Schweizer KI-Technologie",
      platform: "YouTube & Website",
      description: "Innovative KI-Erklärvideos für Schweizer Fintech und Health-Tech Unternehmen. Die KI-generierten Videos verbessern das Kundenverständnis um 82% und steigern die Conversion-Raten bei komplexen Dienstleistungen um 64%.",
      gradientClass: "from-amber-600/20 to-rose-600/20"
    },
    {
      id: 5,
      title: "Social Media Video-Content-Strategie mit KI",
      platform: "TikTok & Reels",
      description: "Ganzheitliche KI-gestützte Video-Content-Strategie für Social Media mit Schweizer Know-how. Algorithmus-optimierte Kurzvideoinhalte sorgen für 5-fach höheres Engagement bei 60% reduzierten Produktionskosten.",
      gradientClass: "from-rose-600/20 to-purple-600/20"
    }
  ];

  return (
    <section className="py-20 bg-[#0A0A0A] relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            KI-Videomarketing Ideen für die Schweiz
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Innovative, auf den Schweizer Markt optimierte KI-Videokonzepte für alle relevanten Social-Media-Plattformen.
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto mb-16">
          <div className="bg-[#111116]/80 backdrop-blur-sm border border-purple-900/20 rounded-xl p-8">
            <h3 className="text-2xl font-semibold text-white mb-4">
              Innovative Video-Marketing Strategien für Ihren Erfolg
            </h3>
            <div className="text-gray-300 space-y-4">
              <p>
                Entdecken Sie die Kraft moderner Videomarketing-Strategien, die Ihre Marke auf das nächste Level heben. Von aufmerksamkeitsstarken Erklärvideos bis hin zu überzeugenden Social-Media-Inhalten schaffen wir maßgeschneiderte Videolösungen für Ihre Marketingziele:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><span className="text-purple-300 font-medium">Produkt-Demonstrationen:</span> Präsentieren Sie Ihre Produkte mit dynamischen und interaktiven Video-Demonstrationen, die Funktionalität und Mehrwert klar vermitteln.</li>
                <li><span className="text-purple-300 font-medium">Social Media Video-Ads:</span> Erzielen Sie höchste Konversionsraten durch optimierte Videoanzeigen für TikTok, Instagram, LinkedIn und Facebook.</li>
                <li><span className="text-purple-300 font-medium">Brand-Storytelling:</span> Verbinden Sie sich emotional mit Ihrer Zielgruppe durch wirkungsvolle Video-Geschichten, die Ihre Markenidentität stärken.</li>
                <li><span className="text-purple-300 font-medium">Bildungsinhalte:</span> Etablieren Sie sich als Branchenexperte durch informative und wertvolle Video-Tutorials und Webinare.</li>
              </ul>
              <p>
                KI-gestützte Videos revolutionieren das Marketing in der Schweiz durch messbare Ergebnisse: höhere Engagement-Raten, verbesserte Conversion und signifikant gesteigerten ROI bei gleichzeitig reduzierten Produktionskosten. Unsere mehrsprachigen Videolösungen sind optimal für den vielfältigen Schweizer Markt konzipiert.
              </p>
            </div>
          </div>
        </div>
        
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {marketingIdeas.map((idea) => (
            <div key={idea.id} className="bg-gradient-to-r border border-purple-500/20 rounded-xl p-6 shadow-xl h-full flex flex-col"
              style={{background: `linear-gradient(to right, rgba(124, 58, 237, 0.1), rgba(0, 0, 0, 0))`}}
            >
              <div className="bg-black/40 backdrop-blur-sm px-3 py-1 rounded-full border border-purple-500/40 inline-block mb-4">
                <span className="text-sm text-purple-300">{idea.platform}</span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3">{idea.title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed">{idea.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExampleGallery;
